import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

import { SearchVersionUsed } from 'shared/const/searchVersionPreference';

const SEARCH_VERSION_HEADER_NAMES = [
    'x-search-version',
    'X-Search-Version',
] as const;

const normalizeSearchVersion = (value: string): SearchVersionUsed | null => {
    const normalized = value.trim().toLowerCase();

    if (normalized === 'v1' || normalized === 'v2') {
        return normalized;
    }

    return null;
};

const readHeaderValue = (
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders,
    headerName: string,
): string | undefined => {
    if (typeof headers.get === 'function') {
        const value = headers.get(headerName);

        if (typeof value === 'string') {
            return value;
        }

        if (Array.isArray(value)) {
            return value[0];
        }
    }

    const normalizedHeaderName = headerName.toLowerCase();
    const record = headers as Record<string, string | string[] | undefined>;
    const value =
        record[headerName] ?? record[normalizedHeaderName] ?? undefined;

    if (Array.isArray(value)) {
        return value[0];
    }

    return typeof value === 'string' ? value : undefined;
};

export const getSearchVersionFromResponseHeaders = (
    headers: RawAxiosResponseHeaders | AxiosResponseHeaders | undefined,
): SearchVersionUsed | null => {
    if (!headers) {
        return null;
    }

    for (const headerName of SEARCH_VERSION_HEADER_NAMES) {
        const searchVersion = readHeaderValue(headers, headerName);

        if (searchVersion) {
            const normalized = normalizeSearchVersion(searchVersion);

            if (normalized) {
                return normalized;
            }
        }
    }

    return null;
};
